function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_2_svg__a{fill:#e6e6e6}.step_2_svg__b,.step_2_svg__d{fill:#fff}.step_2_svg__c{fill:#3f3d56}.step_2_svg__d{stroke:rgba(165,155,195,.47)}.step_2_svg__e{fill:#614cb4}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-742.652 -3826.216)"
}, /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__a",
  d: "M853.159 3897.992h-86.134c-.552 0-1-.329-1-.734v-58.641c0-.405.449-.733 1-.734h86.134c.552 0 1 .329 1 .734v58.641c0 .405-.448.733-1 .734zm-86.129-59.816c-.331 0-.6.2-.6.44v58.642c0 .243.269.439.6.44h86.129c.331 0 .6-.2.6-.44v-58.641c0-.243-.269-.439-.6-.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__a",
  d: "M874.37 3889.728h-86.134c-.552 0-1-.329-1-.734v-58.641c0-.405.449-.733 1-.734h86.134c.552 0 1 .329 1 .734v58.641c0 .405-.448.733-1 .734zm-86.129-59.816c-.331 0-.6.2-.6.44v58.642c0 .243.269.439.6.44h86.129c.331 0 .6-.2.6-.44v-58.641c0-.243-.269-.439-.6-.44z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__a",
  cx: 5.089,
  cy: 5.089,
  r: 5.089,
  transform: "translate(863.67 3875.592)"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__b",
  d: "M871.401 3880.588l-4.057-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.057-2.342a.105.105 0 000-.182l-4.057-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.057-2.342a.105.105 0 000-.182z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M830.2 3877.685a2.374 2.374 0 01-.964-.205 1.172 1.172 0 01-.2-.114l-6.135-4.319a2.373 2.373 0 01-1.007-1.94v-5.889a2.374 2.374 0 011.007-1.94l6.135-4.319a1.176 1.176 0 01.2-.114 2.374 2.374 0 013.338 2.169v14.3a2.374 2.374 0 01-2.374 2.374z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M816.469 3878.844h-17.111c-3.491 0-6.32-2.259-6.324-5.044v-11.274c0-2.785 2.833-5.041 6.324-5.044h17.156c3.466 0 6.275 2.244 6.279 5.008v11.31c-.004 2.785-2.833 5.042-6.324 5.044z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__a",
  cx: 5.089,
  cy: 5.089,
  r: 5.089,
  transform: "translate(841.861 3883.33)"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M783.077 3826.717h93.764a1.427 1.427 0 011.383 1.467v65.185a1.427 1.427 0 01-1.383 1.467h-93.764a1.427 1.427 0 01-1.383-1.467v-65.185a1.427 1.427 0 011.383-1.467z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M787.75 3831.529h84.417a1.253 1.253 0 011.245 1.26v55.975a1.253 1.253 0 01-1.245 1.26H787.75a1.253 1.253 0 01-1.245-1.26v-55.975a1.253 1.253 0 011.245-1.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M763.03 3834.102h93.764a1.427 1.427 0 011.383 1.467v65.185a1.427 1.427 0 01-1.383 1.467H763.03a1.427 1.427 0 01-1.383-1.467v-65.185a1.427 1.427 0 011.383-1.467z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M767.703 3838.914h84.417a1.253 1.253 0 011.245 1.26v55.975a1.253 1.253 0 01-1.245 1.26h-84.417a1.253 1.253 0 01-1.245-1.26v-55.975a1.253 1.253 0 011.245-1.26z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.863 -10.178)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__e",
  cx: 5.089,
  cy: 5.089,
  r: 5.089,
  transform: "translate(820.473 3892.195)"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__b",
  d: "M828.206 3897.193l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.67 -18.44)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__e",
  cx: 5.089,
  cy: 5.089,
  r: 5.089,
  transform: "translate(820.473 3892.195)"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__b",
  d: "M828.206 3897.193l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182z"
})), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M744.534 3842.622h93.764a1.427 1.427 0 011.383 1.467v65.185a1.427 1.427 0 01-1.383 1.467h-93.764a1.427 1.427 0 01-1.383-1.467v-65.185a1.427 1.427 0 011.383-1.467z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__d",
  d: "M749.207 3847.434h84.417a1.253 1.253 0 011.245 1.26v55.975a1.253 1.253 0 01-1.245 1.26h-84.417a1.253 1.253 0 01-1.245-1.26v-55.975a1.253 1.253 0 011.245-1.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__e",
  d: "M808.813 3886.551a2.375 2.375 0 01-.964-.206 1.164 1.164 0 01-.2-.114l-6.135-4.319a2.374 2.374 0 01-1.007-1.94v-5.89a2.373 2.373 0 011.007-1.94l6.136-4.319a1.169 1.169 0 01.2-.114 2.374 2.374 0 013.338 2.169v14.3a2.374 2.374 0 01-2.374 2.374z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__e",
  d: "M795.082 3887.708h-17.111c-3.491 0-6.32-2.259-6.324-5.044v-11.274c0-2.785 2.833-5.041 6.324-5.044h17.156c3.466 0 6.275 2.244 6.279 5.008v11.31c-.004 2.785-2.833 5.042-6.324 5.044z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__e",
  cx: 5.089,
  cy: 5.089,
  r: 5.089,
  transform: "translate(820.473 3892.195)"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__b",
  d: "M828.206 3897.193l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182l-4.056-2.342a.105.105 0 00-.158.091v4.684a.105.105 0 00.158.091l4.056-2.342a.105.105 0 000-.182z"
}));

function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.073 85.026",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgStep2;